jQuery(document).ready(function ($) {

  //TODO: Mehrere dieser Module auf einer Seite hiermit möglich? GGf.- anpassen.

  if($('.f-readmore')){

    var setLinkFunction = function(){
      $('.f-readmore-link').click(function(event){
        event.preventDefault();
        $('.f-readmore .full-text').slideToggle();
        $('.f-readmore .excerpt').toggleClass('is-visible');
        $('.f-readmore-link').toggleClass('is-open');
        toggleLinkLabel('.f-readmore-link', $trigger_label, $trigger_label_opened);
      });
    };
    
    var setCols = function(){
      if (window.matchMedia('(max-width: 768px)').matches){ 
        if($readmore_status == 'desktop' || $readmore_status == ''){
          setMobile();
        } 
      } else {
        if($readmore_status == 'mobile' || $readmore_status == ''){
          setDesktop();
        }
      }
    };

    var setMobile = function(){
      addMobileContainer('.f-readmore');
      addExcerpt('.textcol-mobile');
      addFullText('.textcol-mobile');
      addReadMore('.textcol-mobile');
      setLinkFunction();
      $readmore_status = 'mobile';
    };

    var setDesktop = function(){
      $('.f-readmore').html($desktop);
      $readmore_status = 'desktop';
    };

    var getContent = function(){
      $desktop = $('.f-readmore').html();
      $mobile = $('.f-readmore').text();
    };

    var formatExcerpt = function(str, words){
      $result = '<div class="excerpt is-visible"><p>'+str.trim().split(" ").splice(0,words).join(" ")+' …</p></div>';
      return $result;
    };

    var formatFullText = function(str){
      $result = '<div class="full-text"><p>'+str.trim()+'</p></div>';
      return $result;
    };

    var setVisibility = function(){
      $('.f-readmore').css('opacity', 1);
    };

    var addReadMore = function (target){
      $link = '<a href="#" class="f-readmore-link"><span class="label">Mehr anzeigen …</span></a>';
      $(target).append($link);
    };

    var addExcerpt = function(target){
      $excerpt = formatExcerpt($mobile, 60);
      $(target).html($excerpt);
    };

    var addFullText = function(target){
      $text = formatFullText($mobile);
      $(target).append($text);
    };

    var addMobileContainer = function(target){
      $(target).html('<div class="textcol-mobile col col-24"></div>');
    };

    $trigger_label = 'Mehr anzeigen …';
    $trigger_label_opened = 'Weniger anzeigen …';

    var toggleLinkLabel = function ($trigger, $trigger_label, $trigger_label_opened){
      if($($trigger).hasClass('is-open')){
        $($trigger).find('.label').text($trigger_label_opened);
      } else {
        $($trigger).find('.label').text($trigger_label);
      }
    };

    var init = function(){
      $readmore_status = '';
      getContent();
      setCols();
      setVisibility();
    };

    $(window).on('resize', function(){
      setCols();
    });
    
    //init
    init();
  
  } 
});